<template>
  <main id="container" class="page-container bg-wave5">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="메인" />
        </div>
      </div>
    </div>
    <div class="page-content event-check event-LastWinPage">
      <div class="container">
        <div class="page-sub-header">
          <!-- <h3 class="page-sub-title">
            <span class="green">동행축제 이벤트에 참여하고</span> 푸짐한 선물
            받으세요.
          </h3> -->
        </div>
      </div>
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/event_winner_0625.png"
                  alt="이벤트 당첨자"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/event_winner_06251.png"
                  alt="이벤트 당첨자"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="container">
        <div class="event-check-container">
          <div class="event-check-header">
            <div class="event-check-header-img">
              <div class="banner-img">
                <img
                  src="@/assets/img/event/event_winner_06252.png"
                  alt="이벤트 당첨자"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <event-terms-modal
      :visible="visibleModal"
      @closeModal="visibleModal = false"
    />
  </main>
</template>
<script>
import PageHeader from "@/components/content/PageHeader";
import EventTermsModal from "@/components/content/EventTermsModal";
import { mapGetters } from "vuex";
export default {
  name: "EventLastWinPage",
  components: { PageHeader, EventTermsModal },
  data: () => ({}),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
  },
  watch: {},
  async created() {},
  mounted() {},
  methods: {
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.event-LastWinPage .event-check-container {
  max-width: 80%;
  margin: 0 auto;
}
</style>
